import React from 'react'

function MedicineReminder() {
const [visible, setVisible] = React.useState(true)
const props = arguments[0] || {}
const slot = props.slot || 'medication' // you can pass a slot prop like <MedicineReminder slot="Morning" />

React.useEffect(() => {
    const t = setTimeout(() => setVisible(false), 10000) // auto-hide after 10s
    return () => clearTimeout(t)
}, [])

if (!visible) return null

const containerStyle = {
    position: 'fixed',
    right: 20,
    bottom: 20,
    zIndex: 1000,
}

const boxStyle = {
    background: '#fff',
    color: '#111',
    padding: '12px 16px',
    borderRadius: 8,
    boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 220,
}

const titleStyle = { fontSize: 13, fontWeight: 600, marginBottom: 4 }
const textStyle = { fontSize: 13, margin: 0 }
const closeStyle = {
    background: 'transparent',
    border: 'none',
    fontSize: 16,
    lineHeight: 1,
    cursor: 'pointer',
    color: '#666',
    padding: 4,
}

return (
    <div style={containerStyle} role="status" aria-live="polite">
        <div style={boxStyle}>
            {/* Icon (use provided prop or fallback to asset) */}
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                <img
                    src="./reminder.jpg"
                    alt=""
                    aria-hidden="true"
                    width="50"
                    height="50"
                    style={{ display: 'block' }}
                />
            </div>

            <div style={{ flex: 1 }}>
                <div style={titleStyle}>Reminder</div>
                <div style={textStyle}>Time for {slot}</div>
            </div>
            <button
                aria-label="Close reminder"
                style={closeStyle}
                onClick={() => setVisible(false)}
            >
                ×
            </button>
        </div>
    </div>
)
}

export default MedicineReminder;